export default __webpack_public_path__ + "static/media/sync.f2645eee.png";